/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChargeItemByAccountResponseModel } from '../models';
// @ts-ignore
import type { ChargeItemByEncounterResponseModel } from '../models';
// @ts-ignore
import type { ChargeItemSearch } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { SearchFhirChargeItems200Response } from '../models';
/**
 * FHIRChargeItemApi - axios parameter creator
 * @export
 */
export const FHIRChargeItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get charge items by encounter id grouped by account id
         * @summary Get charge items by encounter id grouped by account id
         * @param {string} encounterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChargeItemsByEncounterGroupedByAccount: async (encounterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encounterId' is not null or undefined
            assertParamExists('getChargeItemsByEncounterGroupedByAccount', 'encounterId', encounterId)
            const localVarPath = `/api/v1/fhir/chargeItem/getByEncounter/{encounterId}`
                .replace(`{${"encounterId"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search charge items with advanced filters
         * @summary Search charge items
         * @param {ChargeItemSearch} chargeItemSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirChargeItems: async (chargeItemSearch: ChargeItemSearch, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeItemSearch' is not null or undefined
            assertParamExists('searchFhirChargeItems', 'chargeItemSearch', chargeItemSearch)
            const localVarPath = `/api/v1/fhir/chargeItem/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chargeItemSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search charge items with advanced filters and group results by account
         * @summary Search charge items grouped by account (no pagination)
         * @param {ChargeItemSearch} chargeItemSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirChargeItemsGroupedByAccount: async (chargeItemSearch: ChargeItemSearch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeItemSearch' is not null or undefined
            assertParamExists('searchFhirChargeItemsGroupedByAccount', 'chargeItemSearch', chargeItemSearch)
            const localVarPath = `/api/v1/fhir/chargeItem/searchGroupedByAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chargeItemSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search charge items with advanced filters, grouped by encounter (no pagination)
         * @summary Search charge items grouped by encounter (no pagination)
         * @param {ChargeItemSearch} chargeItemSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirChargeItemsGroupedByEncounter: async (chargeItemSearch: ChargeItemSearch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chargeItemSearch' is not null or undefined
            assertParamExists('searchFhirChargeItemsGroupedByEncounter', 'chargeItemSearch', chargeItemSearch)
            const localVarPath = `/api/v1/fhir/chargeItem/searchGroupedByEncounter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chargeItemSearch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FHIRChargeItemApi - functional programming interface
 * @export
 */
export const FHIRChargeItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FHIRChargeItemApiAxiosParamCreator(configuration)
    return {
        /**
         * Get charge items by encounter id grouped by account id
         * @summary Get charge items by encounter id grouped by account id
         * @param {string} encounterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChargeItemsByEncounterGroupedByAccount(encounterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChargeItemByAccountResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChargeItemsByEncounterGroupedByAccount(encounterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRChargeItemApi.getChargeItemsByEncounterGroupedByAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search charge items with advanced filters
         * @summary Search charge items
         * @param {ChargeItemSearch} chargeItemSearch 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFhirChargeItems(chargeItemSearch: ChargeItemSearch, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchFhirChargeItems200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFhirChargeItems(chargeItemSearch, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRChargeItemApi.searchFhirChargeItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search charge items with advanced filters and group results by account
         * @summary Search charge items grouped by account (no pagination)
         * @param {ChargeItemSearch} chargeItemSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFhirChargeItemsGroupedByAccount(chargeItemSearch: ChargeItemSearch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChargeItemByAccountResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFhirChargeItemsGroupedByAccount(chargeItemSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRChargeItemApi.searchFhirChargeItemsGroupedByAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search charge items with advanced filters, grouped by encounter (no pagination)
         * @summary Search charge items grouped by encounter (no pagination)
         * @param {ChargeItemSearch} chargeItemSearch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFhirChargeItemsGroupedByEncounter(chargeItemSearch: ChargeItemSearch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChargeItemByEncounterResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFhirChargeItemsGroupedByEncounter(chargeItemSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FHIRChargeItemApi.searchFhirChargeItemsGroupedByEncounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FHIRChargeItemApi - factory interface
 * @export
 */
export const FHIRChargeItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FHIRChargeItemApiFp(configuration)
    return {
        /**
         * Get charge items by encounter id grouped by account id
         * @summary Get charge items by encounter id grouped by account id
         * @param {FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChargeItemsByEncounterGroupedByAccount(requestParameters: FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChargeItemByAccountResponseModel>> {
            return localVarFp.getChargeItemsByEncounterGroupedByAccount(requestParameters.encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search charge items with advanced filters
         * @summary Search charge items
         * @param {FHIRChargeItemApiSearchFhirChargeItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirChargeItems(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchFhirChargeItems200Response> {
            return localVarFp.searchFhirChargeItems(requestParameters.chargeItemSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Search charge items with advanced filters and group results by account
         * @summary Search charge items grouped by account (no pagination)
         * @param {FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirChargeItemsGroupedByAccount(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChargeItemByAccountResponseModel>> {
            return localVarFp.searchFhirChargeItemsGroupedByAccount(requestParameters.chargeItemSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * Search charge items with advanced filters, grouped by encounter (no pagination)
         * @summary Search charge items grouped by encounter (no pagination)
         * @param {FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFhirChargeItemsGroupedByEncounter(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounterRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChargeItemByEncounterResponseModel>> {
            return localVarFp.searchFhirChargeItemsGroupedByEncounter(requestParameters.chargeItemSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FHIRChargeItemApi - interface
 * @export
 * @interface FHIRChargeItemApi
 */
export interface FHIRChargeItemApiInterface {
    /**
     * Get charge items by encounter id grouped by account id
     * @summary Get charge items by encounter id grouped by account id
     * @param {FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRChargeItemApiInterface
     */
    getChargeItemsByEncounterGroupedByAccount(requestParameters: FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChargeItemByAccountResponseModel>>;

    /**
     * Search charge items with advanced filters
     * @summary Search charge items
     * @param {FHIRChargeItemApiSearchFhirChargeItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRChargeItemApiInterface
     */
    searchFhirChargeItems(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchFhirChargeItems200Response>;

    /**
     * Search charge items with advanced filters and group results by account
     * @summary Search charge items grouped by account (no pagination)
     * @param {FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRChargeItemApiInterface
     */
    searchFhirChargeItemsGroupedByAccount(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChargeItemByAccountResponseModel>>;

    /**
     * Search charge items with advanced filters, grouped by encounter (no pagination)
     * @summary Search charge items grouped by encounter (no pagination)
     * @param {FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRChargeItemApiInterface
     */
    searchFhirChargeItemsGroupedByEncounter(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounterRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChargeItemByEncounterResponseModel>>;

}

/**
 * Request parameters for getChargeItemsByEncounterGroupedByAccount operation in FHIRChargeItemApi.
 * @export
 * @interface FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccountRequest
 */
export interface FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccount
     */
    readonly encounterId: string
}

/**
 * Request parameters for searchFhirChargeItems operation in FHIRChargeItemApi.
 * @export
 * @interface FHIRChargeItemApiSearchFhirChargeItemsRequest
 */
export interface FHIRChargeItemApiSearchFhirChargeItemsRequest {
    /**
     * 
     * @type {ChargeItemSearch}
     * @memberof FHIRChargeItemApiSearchFhirChargeItems
     */
    readonly chargeItemSearch: ChargeItemSearch

    /**
     * 
     * @type {number}
     * @memberof FHIRChargeItemApiSearchFhirChargeItems
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof FHIRChargeItemApiSearchFhirChargeItems
     */
    readonly pgSize?: number
}

/**
 * Request parameters for searchFhirChargeItemsGroupedByAccount operation in FHIRChargeItemApi.
 * @export
 * @interface FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccountRequest
 */
export interface FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccountRequest {
    /**
     * 
     * @type {ChargeItemSearch}
     * @memberof FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccount
     */
    readonly chargeItemSearch: ChargeItemSearch
}

/**
 * Request parameters for searchFhirChargeItemsGroupedByEncounter operation in FHIRChargeItemApi.
 * @export
 * @interface FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounterRequest
 */
export interface FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounterRequest {
    /**
     * 
     * @type {ChargeItemSearch}
     * @memberof FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounter
     */
    readonly chargeItemSearch: ChargeItemSearch
}

/**
 * FHIRChargeItemApi - object-oriented interface
 * @export
 * @class FHIRChargeItemApi
 * @extends {BaseAPI}
 */
export class FHIRChargeItemApi extends BaseAPI implements FHIRChargeItemApiInterface {
    /**
     * Get charge items by encounter id grouped by account id
     * @summary Get charge items by encounter id grouped by account id
     * @param {FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRChargeItemApi
     */
    public getChargeItemsByEncounterGroupedByAccount(requestParameters: FHIRChargeItemApiGetChargeItemsByEncounterGroupedByAccountRequest, options?: RawAxiosRequestConfig) {
        return FHIRChargeItemApiFp(this.configuration).getChargeItemsByEncounterGroupedByAccount(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search charge items with advanced filters
     * @summary Search charge items
     * @param {FHIRChargeItemApiSearchFhirChargeItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRChargeItemApi
     */
    public searchFhirChargeItems(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsRequest, options?: RawAxiosRequestConfig) {
        return FHIRChargeItemApiFp(this.configuration).searchFhirChargeItems(requestParameters.chargeItemSearch, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search charge items with advanced filters and group results by account
     * @summary Search charge items grouped by account (no pagination)
     * @param {FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRChargeItemApi
     */
    public searchFhirChargeItemsGroupedByAccount(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsGroupedByAccountRequest, options?: RawAxiosRequestConfig) {
        return FHIRChargeItemApiFp(this.configuration).searchFhirChargeItemsGroupedByAccount(requestParameters.chargeItemSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search charge items with advanced filters, grouped by encounter (no pagination)
     * @summary Search charge items grouped by encounter (no pagination)
     * @param {FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FHIRChargeItemApi
     */
    public searchFhirChargeItemsGroupedByEncounter(requestParameters: FHIRChargeItemApiSearchFhirChargeItemsGroupedByEncounterRequest, options?: RawAxiosRequestConfig) {
        return FHIRChargeItemApiFp(this.configuration).searchFhirChargeItemsGroupedByEncounter(requestParameters.chargeItemSearch, options).then((request) => request(this.axios, this.basePath));
    }
}

